import AddonContext from '../../../../shared/components/utils/context/addonContext';
import DetailAddonDescription from '../../atoms/text/detailAddonDescription';
import DetailAddonInfoLeftContainer from '../../atoms/container/detailAddonInfoLeftContainer';
import DetailAddonInfoPromo from '../../atoms/text/detailAddonInfoPromo';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import { useContext } from 'react';

export default function DetailAddonInfoLeft() {
  const { addon, channels } = useContext(AddonContext);
  return (
    <DetailAddonInfoLeftContainer>
      <DetailAddonInfoPromo>
        {addon?.isFree ? (
          addon?.offerClaim ? (
            <>{addon.offerClaim}</>
          ) : (
            <>
              {' '}
              {TranslationManager.get('PAGES.ADDON.FREE_CHANNELS_1')}
              <br></br>
              {TranslationManager.get('PAGES.ADDON.FREE_CHANNELS_2') +
                (channels?.length && channels.length > 1
                  ? ` ${channels.length} `
                  : ' ') +
                TranslationManager.get('PAGES.ADDON.FREE_CHANNELS_3')}
            </>
          )
        ) : addon?.price ? (
          <>
            {TranslationManager.get('PAGES.ADDON.FOR_ONLY')}
            <br></br>
            {addon?.price?.monthly
              ? TranslationManager.get(
                  'PAGES.ADDON.PROMO_PRICE_MONTH',
                  addon?.price?.monthly?.toString() || undefined
                )
              : null}
            {addon?.price?.monthly && addon?.price?.annually
              ? TranslationManager.get(
                  'PAGES.ADDON.PROMO_PRICE_CONJUNCTION',
                  addon?.price?.annually?.toString() || undefined
                )
              : null}
            {addon?.price.annually
              ? TranslationManager.get(
                  'PAGES.ADDON.PROMO_PRICE_YEAR',
                  addon?.price?.annually?.toString() || undefined
                )
              : null}
          </>
        ) : null}
      </DetailAddonInfoPromo>
      <DetailAddonDescription>{addon?.synopsis}</DetailAddonDescription>
    </DetailAddonInfoLeftContainer>
  );
}
